import React, { DependencyList, useLayoutEffect, useState } from 'react'

const useScaleToFit = (
    containerRef: React.RefObject<HTMLElement | null>,
    contentRef: React.RefObject<HTMLElement | null>,
    dependencies: DependencyList = [],
    padding = 0.95
) => {
    const [scale, setScale] = useState(1)

    const updateScale = () => {
        const container = containerRef.current
        const content = contentRef.current

        if (!container || !content) return

        const containerWidth = container.offsetWidth * padding
        const contentWidth = content.clientWidth

        const newScale = contentWidth > containerWidth ? containerWidth / contentWidth : 1

        setScale(newScale)
    }

    useLayoutEffect(() => {
        updateScale()
    }, dependencies)

    useLayoutEffect(() => {
        const observer = new ResizeObserver(updateScale)

        if (containerRef.current) observer.observe(containerRef.current)

        return () => observer.disconnect()
    }, [])

    return scale
}

export default useScaleToFit
